import { Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { useEffect } from 'react';
import { CheckboxGroupButtons } from '@/components/_common';
import {
  CommissionByMovementFilterByOsDate,
  CommissionByMovementFormValues,
  CommissionByMovementOsStatusType,
} from '@/core/domain/questReport/Reports/CommssionByMovement/CommissionByMovement.types';
import { FormInstance } from 'antd/es/form/Form';

interface Props {
  form: FormInstance<CommissionByMovementFormValues>;
}

const ByMovimentsRadioGroups = ({ form }: Props) => {
  const intl = useIntl();
  const { Title } = Typography;

  const filterByOsDate = Form.useWatch('filterByOsDate', form);

  const situationOptions = [
    {
      value: CommissionByMovementOsStatusType.open,
      label: intl.formatMessage({
        id: 'byMovimentsForm.form.situation.open',
      }),
      disabled: filterByOsDate !== CommissionByMovementFilterByOsDate.entry,
    },
    {
      value: CommissionByMovementOsStatusType.authorized,
      label: intl.formatMessage({
        id: 'byMovimentsForm.form.situation.authorized',
      }),
    },
    {
      value: CommissionByMovementOsStatusType.closed,
      label: intl.formatMessage({
        id: 'byMovimentsForm.form.situation.closed',
      }),
    },
  ];

  useEffect(() => {
    if (filterByOsDate !== CommissionByMovementFilterByOsDate.entry) {
      const currentStatuses = form.getFieldValue('osStatus') || [];

      if (currentStatuses.includes(CommissionByMovementOsStatusType.open)) {
        form.setFieldsValue({
          osStatus: currentStatuses.filter(
            (status: CommissionByMovementOsStatusType) =>
              status !== CommissionByMovementOsStatusType.open,
          ),
        });
      }
    }
  }, [filterByOsDate, form]);

  return (
    <Row gutter={[12, 12]}>
      <Col span={24} md={8}>
        <Title level={5}>
          {intl.formatMessage({
            id: 'byMovimentsForm.form.filterByData',
          })}
        </Title>

        <Form.Item
          name="filterByOsDate"
          initialValue={CommissionByMovementFilterByOsDate.closing}
          noStyle
        >
          <Radio.Group optionType="button" buttonStyle="solid" size="large">
            <Radio value={CommissionByMovementFilterByOsDate.entry}>
              {intl.formatMessage({
                id: 'byMovimentsForm.form.filterByData.entry',
              })}
            </Radio>
            <Radio value={CommissionByMovementFilterByOsDate.authorization}>
              {intl.formatMessage({
                id: 'byMovimentsForm.form.filterByData.authorization',
              })}
            </Radio>
            <Radio value={CommissionByMovementFilterByOsDate.closing}>
              {intl.formatMessage({
                id: 'byMovimentsForm.form.filterByData.closing',
              })}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col span={24} md={8}>
        <Title level={5}>
          {intl.formatMessage({
            id: 'byMovimentsForm.form.situation',
          })}
        </Title>

        <Form.Item
          name="osStatus"
          initialValue={[CommissionByMovementOsStatusType.closed]}
          noStyle
        >
          <CheckboxGroupButtons options={situationOptions} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default ByMovimentsRadioGroups;
